import React, { useEffect, useState, useRef } from "react";
import { ValidationMessage, weekDaysInText, hasRole } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  CHAPTER_EDIT,
  CHAPTER_UPDATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN
} from "../../routes/routes";
import { toast } from "react-toastify";
import Form from 'react-bootstrap/Form';
import { CHAPTER_UPDATED } from "../../constant/constant";
import { FullPageLoader } from '../../components/common/Loader'; // Import the loader component
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import moment from "moment";
import Select from "react-select";
import { Timepicker } from "timepicker-ui-react";
import "timepicker-ui/main.css";

const ChapterEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [filter, setFilter] = useState([]);

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
  };


  const daysOptions = [
    { value: 0, label: "Sunday" },
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" }
  ]

  /**   *
   * @param {*} input
   * @param {*} callback
   */


  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(CHAPTER_UPDATE + id, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(CHAPTER_UPDATED);
          navigate("/chapters");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios.get(CHAPTER_EDIT + id).then((res) => {
      if (res.status === 200 && res.data.success) {
        let responseData = res.data.data;
        setForm({
          id: responseData?.id,
          chapter_name: responseData?.chapter_name,
          address: responseData?.address,
          country_id: responseData?.country_id,
          country_id_selected: {
            value: Number(responseData?.country_id),
            label: responseData?.country_name,
          },
          state_id: responseData?.state_id,
          state_id_selected: {
            value: Number(responseData?.state_id),
            label: responseData?.state_name,
          },
          region_id: responseData?.region_id,
          region_id_selected: {
            value: Number(responseData?.region_id),
            label: responseData?.region_name,
          },
          pincode: responseData?.pincode,
          status: responseData?.status,
          launching_date: moment(responseData?.launching_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          is_chapter_launched: responseData?.is_chapter_launched,
          is_chapter_already_launched: responseData?.is_chapter_launched,
          weekly_meeting_days: responseData?.weekly_meeting_days,
          weekly_meeting_days_selected: {
            value: responseData?.weekly_meeting_days,
            label: weekDaysInText(responseData?.weekly_meeting_days),
          },
          weekly_meeting_time: moment(
            responseData?.weekly_meeting_time,
            "hh:mm a",
          ).format("hh:mm A"),
          weekly_meeting_fees: responseData?.weekly_meeting_fees
        });
      }
    }).finally(() => {
      setLoading(false);
    });

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Chapters</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/chapters"}>
                    <span>Chapters List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit Chapter</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/chapters"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        {/* <div className="demo-inline-spacing d-flex justify-content-end mb-3">
          <Link to={"/chapters"}>
            <button type="button" className="btn btn-dark rounded-pill">
              <i className="bx bx-exit"></i> back
            </button>
          </Link>
        </div> */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit Chapter</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">

                    {hasRole([1]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            options={countryOptions}
                            isDisabled={true}
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({ ...form, country_id: Number(selected?.value), country_id_selected: selected, state_id: null, state_id_selected: null, region_id_selected: null, region_id: null });
                              setFilter({ ...filter, country_id: selected?.value, state_id: null, region_id: null })
                            }}
                            value={form?.country_id_selected}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    }

                    {hasRole([1, 6]) &&
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label
                            className="form-label"
                            htmlFor="state_id"
                          >
                            State<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            ref={selectStateRef}
                            isDisabled={true}
                            options={stateOptions}
                            onChange={(selected) => {
                              handleRegionClear();
                              setForm({ ...form, state_id: selected?.value, state_id_selected: selected, region_id_selected: null, region_id: null });
                              setFilter({ ...filter, state_id: selected?.value, region_id: null })
                            }}
                            value={form?.state_id_selected}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    }

                    {hasRole([1, , 6, 7]) &&
                      <div className="col-6 mb-3">
                        <label htmlFor="region_id" className="form-label">
                          Region<span className="text-danger">*</span>
                        </label>
                        <Select
                          ref={selectRegionRef}
                          options={regionOptions}
                          isDisabled={true}
                          onChange={(selected) => {
                            setForm({ ...form, region_id: selected?.value, region_id_selected: selected });
                            setFilter({ ...filter, region_id: selected?.value })
                          }}
                          value={form?.region_id_selected}
                        />
                        <ValidationMessage error={errors} name="region_id" />
                      </div>
                    }

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="chapter_name"
                        >
                          Chapter Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="chapter_name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, chapter_name: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, chapter_name: e.target.value })
                          }
                          defaultValue={form?.chapter_name}
                        />
                        <ValidationMessage error={errors} name="chapter_name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="address"
                        >
                          Chapter Location<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          placeholder="Location"
                          onChange={(e) =>
                            setForm({ ...form, address: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, address: e.target.value })
                          }
                          defaultValue={form?.address}
                        />
                        <ValidationMessage error={errors} name="address" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="pincode"
                        >
                          Chapter Pincode<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control hide-arrow"
                          id="pincode"
                          placeholder="Pincode"
                          onChange={(e) =>
                            setForm({ ...form, pincode: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, pincode: e.target.value })
                          }
                          defaultValue={form?.pincode}
                        />
                        <ValidationMessage error={errors} name="pincode" />
                      </div>
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="weekly_meeting_days" className="form-label">
                        Weekly Meeting Day<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={daysOptions}
                        value={form?.weekly_meeting_days_selected}
                        onChange={(selected) => setForm({ ...form, weekly_meeting_days: selected.value, weekly_meeting_days_selected: selected })}
                      />
                      <ValidationMessage error={errors} name="weekly_meeting_days" />
                    </div>

                    <div className="col-6 mb-3">
                      <label
                        htmlFor="weekly_meeting_time"
                        className="form-label"
                      >
                        Meeting Time<span className="text-danger">*</span>
                      </label>
                      <Timepicker
                        id="weekly_meeting_time"
                        className="form-control"
                        placeholder="Select Weekly Meeting Time"
                        options={{
                          clock: { type: "12h" },
                          ui: { clearButton: true },
                        }}
                        defaultValue={form?.weekly_meeting_time}
                        onConfirm={(data) => {
                          const hour = data?.hour;
                          const minutes = data?.minutes;
                          const type = data?.type;
                          let timeStr = `${hour}:${minutes} ${type}`;
                          const formatted = moment(timeStr, [
                            "h:mm A",
                            "HH:mm",
                          ]).format("HH:mm:ss");
                          setForm({
                            ...form,
                            weekly_meeting_time: formatted,
                          });
                        }}
                        onClear={() => {
                          setForm({ ...form, weekly_meeting_time: "" });
                        }}
                      />
                      <ValidationMessage
                        error={errors}
                        name="weekly_meeting_time"
                      />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="weekly_meeting_fees"
                        >
                          Weekly Meeting Fees<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          id="weekly_meeting_fees"
                          placeholder="Fees"
                          onChange={(e) =>
                            setForm({ ...form, weekly_meeting_fees: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, weekly_meeting_fees: e.target.value })
                          }
                          defaultValue={form?.weekly_meeting_fees}
                        />
                        <ValidationMessage error={errors} name="weekly_meeting_fees" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="launching_date"
                        >
                          Chapter Launching Date<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          className="form-control"
                          disabled={form?.is_chapter_already_launched === 1}
                          options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                            minDate: form?.is_chapter_launched === 1 ? null : 'today',
                            onChange: (selected) =>
                              setForm({
                                ...form,
                                launching_date: moment(selected[0]).format("YYYY-MM-DD"),
                              }),
                          }}
                          value={form?.launching_date}
                          placeholder="Select Launching Date"
                        />
                        <ValidationMessage error={errors} name="launching_date" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="is_chapter_launched"
                        >
                          Is Chapter Launched
                        </label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          value="1"
                          disabled={form?.is_chapter_already_launched === 1}
                          checked={form?.is_chapter_launched === 1}
                          label=""
                          onChange={(event) => {
                            const statusVal = (event.target.checked) ? 1 : 0;
                            setForm({
                              ...form,
                              is_chapter_launched: statusVal,
                            })
                          }}
                        />
                        <ValidationMessage error={errors} name="is_chapter_launched" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/chapters"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterEdit;
